import React from 'react';
import Chart from 'react-apexcharts';

const WeekestComponent = ({ domain, weakestCaptureChart }) => {

  const options = {
    chart: {
      background: '#f4f5fa',
      id: 'weakest-chart',

      events: {
        mounted: (chartContext) => {
          // ✅ Direct chart instance milta hai
          if (chartContext) {
            weakestCaptureChart(chartContext);
          }
        }
      }
    },

    colors: ["#cbcbcb"],

    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: "70%",
          background: "#A9A9A9"
        },
        track: {
          dropShadow: {
            enabled: true,
            top: 2,
            left: 0,
            blur: 4,
            opacity: 0.15
          }
        },
        dataLabels: {
          name: {
            offsetY: -10,
            color: "#fff",
            fontSize: "18px",
            fontWeight: '600',
          },
          value: {
            color: "#fff",
            fontSize: "30px",
            fontWeight: '900',
            show: true,
            formatter: function (val) {
              return (val * 7) / 100;
            }
          }
        }
      },
    },

    stroke: {
      lineCap: "round"
    },

    labels: [domain?.name || '']
  };

  const series = [domain ? (domain.score * 100) / 7 : 0];

  return (
    <div>
      <Chart
        options={options}
        series={series}
        type="radialBar"
        height="250"
      />
    </div>
  );
};

export default WeekestComponent;